import React from "react";
import "./Css/Gramsabha.css";

import img2 from "./Images/gav1.jpg";   
import img1 from "./Images/gav3.jpg";   
import img3 from "./Images/gav4.jpg";   
import img4 from "./Images/gav5.jpg";   
import img5 from "./Images/gav2.jpg";  


export default function Gav() {
  return (
    <section className="gramsabha-section">
      <h2 className="gramsabha-title">गावामध्ये श्रमदान ग्रामस्वच्छता अभियान 
</h2>

      <div className="gramsabha-layout">

        {/* LEFT BIG IMAGE */}
        <div className="item item1">
          <img src={img1} alt="" />
         
          
        </div>

        {/* TOP RIGHT - 2 IMAGES */}
        <div className="item item2">
          <img src={img2} alt="" />
        </div>

        <div className="item item3">
          <img src={img3} alt="" />
        </div>

        {/* CENTER BIG IMAGE */}
        <div className="item item4">
          <img src={img4} alt="" />
        </div>

        {/* RIGHT IMAGE */}
        <div className="item item5">
          <img src={img5} alt="" />
        </div>
      </div>
    </section>
  );
}
